export function getTherapistIdFromUser(user) {
  if (!user) return null;

  // mismo patrón robusto que ya venías usando
  if (user.user?.therapists?.length > 0) return user.user.therapists[0];
  if (user.user?.therapist) return user.user.therapist;
  if (user.therapist) return user.therapist;

  if (user.user?.therapistId) return user.user.therapistId;
  if (user.therapistId) return user.therapistId;

  if (user._id) return user._id;
  return null;
}

export function hasRealQuestions(ev) {
  if (!ev || !Array.isArray(ev.questions)) return false;
  return ev.questions.some(
    (q) => typeof q?.text === "string" && q.text.trim().length > 0,
  );
}

export function filterByTitle(items, search) {
  const q = (search || "").trim().toLowerCase();
  if (!q) return items || [];
  return (items || []).filter((e) => (e.title || "").toLowerCase().includes(q));
}
